import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Structure, FormatCurrency } from '@/common/helpers/structure.helper'
import ApplicationData from '@/common/service/application-data.service'

@Component({})
export class ModalProduto extends Vue {

    public produtoModal: Object = {};
    public helper: any          = new Structure();
    public helperFormat         = new FormatCurrency();
    public slug                 = ApplicationData.getSlugClient();
    public settingsCarousel     = {'slidesToShow': 1, 'slidesToScroll': 1};
    public qtdSacola: number    = 3;
    
    @Prop({})
    public dataProduto?: any;

    @Watch('dataProduto')
    onPropertyChanged(value: string) {
        this.produtoModal = value;
    }

    created(){
        document.documentElement.style.overflow = 'hidden';
        this.produtoModal = this.dataProduto;
    }

    public closeModal(){
        this.$emit('actionModal', false);
        document.documentElement.style.overflow = 'auto';
    }

}